module.exports = __webpack_public_path__ + "assets/retina_9PointCircleDetailed.664f93e5eddd293de2d5582b4d5fa57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_9PointCircleDetailed.png
// module id = 605
// module chunks = 0